export const UPDATE_SNACK = 'update-snackbar'

/**
 * Action permettant de mettre à jour la snackbar
 */
export const updateAction = (data) => dispatch => dispatch({
	type: UPDATE_SNACK,
	payload: data
})
